import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { CampaignDetailsContainer } from "@/components/features/marketing/campaign/details/default/ui/existing/container";

import { useGetCampaignDetailsPageParams } from "./_hooks/use-get-campaign-details-page-params";

export const MarketingCampaignDetailsPage = () => {
	const { hotelID, campaignID } = useGetCampaignDetailsPageParams();

	return (
		<PageMeta
			title="キャンペーンの詳細"
			url={generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.DETAILS, { hotelID, campaignID })}
		>
			<CampaignDetailsContainer hotelID={hotelID} campaignID={campaignID} />
		</PageMeta>
	);
};

MarketingCampaignDetailsPage.displayName = "MarketingCampaignDetailsPage";
